/**
 * Configures the HTTP provider in order to intercept the requests and detect unauthorized
 * responses.
 * @param {ngHTTPProvider} $httpProvider The interface for the service that handles HTTP requests
 *                                       on AngularJS.
 * @ngesdoc config
 * @ngprovider $httpProvider
 * @ngmodule auth
 */
const httpProviderConfig = ($httpProvider) => {
  'ngInject';

  // Push the interceptor that validates unauthorized responses.
  $httpProvider.interceptors.push('ssoAuthInterceptor');
};

export default httpProviderConfig;
